import { BASE_URL } from "config/env";

const Apiurl = {
  Baseurl: `${BASE_URL}/`,
};
export default Apiurl;
